/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Leave_ConfirmInputs */

const en_us2_coaching_leave_confirm = /** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm: leave`)
};

const pt_br2_coaching_leave_confirm = /** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar: sair`)
};

const pt_pt2_coaching_leave_confirm = /** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar: sair`)
};

/** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */
const es_419_coaching_leave_confirm = en_us2_coaching_leave_confirm;

/** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */
const fr_fr2_coaching_leave_confirm = en_us2_coaching_leave_confirm;

/** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */
const de_de2_coaching_leave_confirm = en_us2_coaching_leave_confirm;

/** @type {(inputs: Coaching_Leave_ConfirmInputs) => LocalizedString} */
const it_it2_coaching_leave_confirm = en_us2_coaching_leave_confirm;

/**
* | output |
* | --- |
* | "Confirm: leave" |
*
* @param {Coaching_Leave_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_leave_confirm = /** @type {((inputs?: Coaching_Leave_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Leave_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_leave_confirm(inputs)
	if (locale === "es-419") return es_419_coaching_leave_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_leave_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_leave_confirm(inputs)
	if (locale === "de-DE") return de_de2_coaching_leave_confirm(inputs)
	if (locale === "it-IT") return it_it2_coaching_leave_confirm(inputs)
	return en_us2_coaching_leave_confirm(inputs)
});
export { coaching_leave_confirm as "coaching.leave_confirm" }